<template>
  <div class="sidebar sidebar-style-2" :data-background-color="darkSidebar ? 'dark' : ''">
    <div class="sidebar-wrapper scrollbar scrollbar-inner">
      <div class="sidebar-content">
        <div class="user">
          <div class="avatar-sm float-left mr-2">
            <img
              :src="user.profile_image_small || user.profile_image || defaultImage"
              alt="..."
              class="avatar-img rounded-circle"
              onerror="this.src = '/static/img/img-placeholder-dark.jpg'"
            />
            <i class="fa fa-certificate text-warning" v-if="user.subscription"></i>
          </div>
          <div class="info">
            <router-link data-toggle="collapse" to="/account/profile" aria-expanded="true">
              <span>
                {{ user.name || user.username }}
                <span
                  class="user-level"
                  v-if="user.role === 'admin'"
                >{{ $t('administrator') }}</span>
                <span
                  class="user-level"
                  v-if="user.custom_label && user.role !== 'admin'"
                >Record Label</span>
                <span
                  class="user-level"
                  v-if="user.role !== 'admin' && !user.custom_label && !user.subscription"
                >{{ $t('artist') }}</span>
                <span
                  class="user-level"
                  v-if="user.role !== 'admin' && !user.custom_label && user.subscription"
                >Pro Artist</span>
              </span>
            </router-link>
            <div class="clearfix"></div>
          </div>
        </div>
        <ul class="nav nav-danger">
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Dashboard' }">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
              <p>Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Distributions' }">
            <router-link to="/distributions">
              <i class="flaticon-music-player"></i>
              <p>{{ $t('my_releases') }}</p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Artists' }">
            <router-link to="/artists">
              <i class="flaticon-users"></i>
              <p>{{ $t('artists') }}</p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Analytics' }" v-if="hasArtists">
            <router-link to="/analytics">
              <i class="flaticon-graph-2"></i>
              <p>Analytics <span v-if="user.subscription">Pro</span></p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'ExtraTools' }">
            <router-link to="/tools">
              <i class="fa fa-toolbox"></i>
              <p>{{ $t('extra_tools') }}</p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Feed' }">
            <router-link to="/feed">
              <i class="fas fa-compact-disc"></i>
              <p>{{ $t('latest_releases') }}</p>
            </router-link>
          </li>
          <li class="nav-item" @click="hideMenu()" :class="{ active: currentPage === 'Upgrade' }" v-if="!user.subscription">
            <router-link to="/upgrade">
              <i class="fa fa-rocket text-primary"></i>
              <p class="fw-extrabold text-primary">{{ $t('upgrade_to_pro') }}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Artists from '../services/artists'

export default {
  name: 'Sidebar',
  data: function () {
    return {
      artists: [],
      darkSidebar: false,
      hasArtists: false,
      currentPage: this.$route.name,
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      user: {}
    }
  },
  watch: {
    $route (to, from) {
      this.currentPage = to.name

      if (this.$route.path.match(/challenges/)) {
        this.darkSidebar = true
      } else {
        this.darkSidebar = false
      }
    }
  },
  methods: {
    getArtists: function () {
      Artists.getAll({ limit: 1 }).then(response => {
        this.artists = response.data
      })
    },
    hideMenu: function () {
      if (window.$(window).width() < 500 && window.$('html').hasClass('nav_open')) {
        window.$('html').removeClass('nav_open')
      }
    }
  },
  created: function () {
    this.user = this.$user
    this.hasArtists = !!this.user.hasArtistValid

    this.$eventBus.$on('updateArtists', () => {
      this.getArtists()
    })

    this.$eventBus.$on('updateUser', user => {
      this.user = user
    })

    if (this.$route.path.match(/challenges/)) {
      this.darkSidebar = true
    } else {
      this.darkSidebar = false
    }

    this.getArtists()
  },
  mounted: function () {
  }
}
</script>
<style lang="scss" scoped>
.avatar-sm {
  position: relative;

  .fa-certificate {
    position: absolute;
    top: -3px;
    left: -3px;
  }
}

a i {
  margin-right: 5px;
}

.nav-item a i {
  margin-right: 6px;
}

.sidebar.sidebar-style-2 .nav .nav-item a {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue